module.exports = __webpack_public_path__ + "static/media/discount.26818cef.png";